"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactLoadable = require("react-loadable");

var _reactLoadable2 = _interopRequireDefault(_reactLoadable);

var _asyncComponent = require("./asyncComponent");

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppelentSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appellant/AppellantSearch").then(function (module) {
    return module.default;
  });
});
var AssesseeSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appellant/AssesseeSearch").then(function (module) {
    return module.default;
  });
});
var AppelantEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appellant/AppellantEntry").then(function (module) {
    return module.default;
  });
});
var AppealSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appeal/AppealSearch").then(function (module) {
    return module.default;
  });
});
var AppelantDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appeal/AppelantDetails").then(function (module) {
    return module.default;
  });
});
var AppealEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appeal/AppealEntry").then(function (module) {
    return module.default;
  });
});
var AppealView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appeal/AppealSearch/ViewSummary").then(function (module) {
    return module.default;
  });
});
// Old Appeal Judgment Download
var OldAppelJudgementSearchList = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appeal/OldAppealJudgement/index").then(function (module) {
    return module.default;
  });
});

var AppelantView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Appellant/AppellantSearch/ViewSummary").then(function (module) {
    return module.default;
  });
});
var ProceedingSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Proceeding/Search").then(function (module) {
    return module.default;
  });
});
var ProceedingEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Proceeding/Create").then(function (module) {
    return module.default;
  });
});
var ProceedingView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Proceeding/Summary").then(function (module) {
    return module.default;
  });
});
var RateCardEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateCard/Entry").then(function (module) {
    return module.default;
  });
});
var RateCardSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateCard/Search").then(function (module) {
    return module.default;
  });
});
var AssesseeRateCardSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateCard/AssesseeSearch").then(function (module) {
    return module.default;
  });
});
var RateCardView = (0, _asyncComponent2.default)(function () {
  return import("../Screens/RateCard/Search/ViewSummary").then(function (module) {
    return module.default;
  });
});
var LimitationHearingEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/LimitationHearing/Create").then(function (module) {
    return module.default;
  });
});
var LimitationHearingSearch = (0, _asyncComponent2.default)(function () {
  return import("../Screens/LimitationHearing/Search").then(function (module) {
    return module.default;
  });
});

// Master search list
var MasterList = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Master").then(function (module) {
    return module.default;
  });
});

//Demand Print
var SearchAndPrintDemand = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Demand/DemandPrint").then(function (module) {
    return module.default;
  });
});

//Miscellaneous Demand Entry
var MiscellaneousDemandEntry = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Demand/MiscellaneousDemands/DemandEntry").then(function (module) {
    return module.default;
  });
});

//Miscellaneous Demand Search List
var MiscellaneousDemandList = (0, _asyncComponent2.default)(function () {
  return import("../Screens/Demand/MiscellaneousDemands/DemandSearch").then(function (module) {
    return module.default;
  });
});

//Judgement Search List citizen route
var JudgementSearchList = (0, _asyncComponent2.default)(function () {
  return import("../Screens/JudgementDetails/SearchJudgement").then(function (module) {
    return module.default;
  });
});

var OldJudgementDownload = (0, _asyncComponent2.default)(function () {
  return import("../Screens/JudgementDetails/oldJudgementDownload").then(function (module) {
    return module.default;
  });
});

//cause Search List citizen route
var causeSearchList = (0, _asyncComponent2.default)(function () {
  return import("../Screens/CaseCauseDetails/searchcauselist").then(function (module) {
    return module.default;
  });
});

//add hoc status Search List
var AdHocCaseStatusList = (0, _asyncComponent2.default)(function () {
  return import("../Screens/AdHocInformation/CaseStatusSearch").then(function (module) {
    return module.default;
  });
});

//add hoc case proceeding view List
var AdHocCaseProceedingDetails = (0, _asyncComponent2.default)(function () {
  return import("../Screens/AdHocInformation/CaseProccedingDetails").then(function (module) {
    return module.default;
  });
});

//testing stepper
var testingStepper = (0, _asyncComponent2.default)(function () {
  return import("../Screens/AdHocInformation/index").then(function (module) {
    return module.default;
  });
});

var FileUpload = (0, _asyncComponent2.default)(function () {
  return import("../Screens/AdHocInformation/uploadFile").then(function (module) {
    return module.default;
  });
});

// Example route configuration
var routes = [{
  path: "egov-mat/appelant/assessee-search",
  component: AssesseeSearch,
  needsAuthentication: true
}, {
  path: "egov-mat/appelant/appelant-search",
  component: AppelentSearch,
  needsAuthentication: true
}, {
  path: "egov-mat/appelant/appelant-entry",
  component: AppelantEntry,
  needsAuthentication: true
}, {
  path: "egov-mat/appeal/appeal-search",
  component: AppealSearch,
  needsAuthentication: true
}, {
  path: "egov-mat/appeal/appelant-search-appeal",
  component: AppelantDetails,
  needsAuthentication: true
}, {
  path: "egov-mat/appeal/appeal-entry",
  component: AppealEntry,
  needsAuthentication: true
}, {
  path: "egov-mat/appeal/appeal-view",
  component: AppealView,
  needsAuthentication: true
},
// Old Appeal Judgment Route
{
  path: "egov-mat/appeal/old-Judgement-download",
  component: OldAppelJudgementSearchList,
  needsAuthentication: true
}, {
  path: "egov-mat/old-Judgement-download",
  component: OldJudgementDownload,
  needsAuthentication: true
}, {
  path: "egov-mat/appelant/view",
  component: AppelantView,
  needsAuthentication: true
}, {
  path: "egov-mat/proceeding/proceeding-search",
  component: ProceedingSearch,
  needsAuthentication: true
}, {
  path: "egov-mat/proceeding/entry",
  component: ProceedingEntry,
  needsAuthentication: true
}, {
  path: "egov-mat/proceeding/view",
  component: ProceedingView,
  needsAuthentication: true
}, {
  path: "egov-mat/ratecard/entry",
  component: RateCardEntry,
  needsAuthentication: true
}, {
  path: "egov-mat/ratecard/search",
  component: RateCardSearch,
  needsAuthentication: true
}, {
  path: "egov-mat/ratecard/assessee-search",
  component: AssesseeRateCardSearch,
  needsAuthentication: true
}, {
  path: "egov-mat/ratecard/view",
  component: RateCardView,
  needsAuthentication: true
}, {
  path: "egov-mat/limitation-hearing/create",
  component: LimitationHearingEntry,
  needsAuthentication: true
}, {
  path: "egov-mat/limitation-hearing/search",
  component: LimitationHearingSearch,
  needsAuthentication: true
},
//Demand print Route
{
  path: "egov-mat/demand-search/print",
  component: SearchAndPrintDemand,
  needsAuthentication: true
},
//master screen route
{
  path: "egov-mat/master/search",
  component: MasterList,
  needsAuthentication: true
},

//Miscellaneous Demand Entry
{
  path: "egov-mat/demand/miscellaneous/create",
  component: MiscellaneousDemandEntry,
  needsAuthentication: true
},
//Miscellaneous Demand Search List
{
  path: "egov-mat/demand/miscellaneous/searchList",
  component: MiscellaneousDemandList,
  needsAuthentication: true
},

//Judgement  Search List
{
  path: "egov-mat/judgement/searchList",
  component: JudgementSearchList,
  needsAuthentication: true
},

//cause  Search List
{
  path: "egov-mat/case-cause/searchList",
  component: causeSearchList,
  needsAuthentication: true
},

//add hoc status Search List
{
  path: "egov-mat/ad-hoc/case-status-search",
  component: AdHocCaseStatusList,
  needsAuthentication: true
},

//add hoc case proceeding view List
{
  path: "egov-mat/ad-hoc/case-proceedingDetails",
  component: AdHocCaseProceedingDetails,
  needsAuthentication: true
},

//testing steeper
{
  path: "egov-mat/ad-hoc/testing-steeper",
  component: testingStepper,
  needsAuthentication: true
}, {
  path: "egov-mat/ad-hoc/file-upload",
  component: FileUpload,
  needsAuthentication: true
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-mat/Routes/module-routes.js
// module id = 3523
// module chunks = 1137